import React from "react";
import { withFormik, Form, Field } from "formik";
import { FormGroup, Label, Button, ModalFooter } from "reactstrap";
import { FormattedMessage } from "react-intl";
import { toast } from "react-toastify";
import axios from "../../services/api/api";
import * as Yup from "yup";
import { TOAST_CONFIG } from "../../Utilities/toastConfig";

const ImportForm = ({
  errors,
  touched,
  isSubmitting,
  dismissModal,
  studentClasses,
  setFieldValue,
  values,
  preSelectedClass,
}) => {
  const handleFileChanged = (file) => {
    setFieldValue("file", file);
  };

  return (
    <div className="col-12 col-sm-12">
      <h5>
        <a download href="static/mall_elevimport.xlsx">
          Ladda hem importmall
        </a>
      </h5>
      <Form>
        {preSelectedClass === true ? (
          ""
        ) : (
          <FormGroup>
            <Label for="studentClassSelect">Välj klass</Label>
            <Field
              component="select"
              name="studentClassId"
              id="studentClassSelect"
              className={`form-control ${
                errors.studentClassId && touched.studentClassId && "is-invalid"
              }`}
            >
              <option
                selected={values.preSelectedClassId}
                value={parseInt("-1", 10)}
              >
                -- Välj en klass från listan --
              </option>
              {studentClasses.map((c) => {
                return (
                  <option key={c.id} value={c.id}>
                    {c.name}
                  </option>
                );
              })}
            </Field>
            {errors.studentClassId && touched.studentClassId && (
              <div className="invalid-feedback">{errors.studentClassId}</div>
            )}
          </FormGroup>
        )}

        <FormGroup>
          <Label for="studentClassSelect">Välj en fil</Label>
          <input
            id="fileId"
            className={`form-control ${
              errors.file && touched.file && "is-invalid"
            }`}
            name="file"
            accept=".xlsx"
            type="file"
            onChange={(e) => handleFileChanged(e.currentTarget.files[0])}
          />
          {errors.file && touched.file && (
            <div className="invalid-feedback">{errors.file}</div>
          )}
        </FormGroup>
        <ModalFooter>
          <Button
            type="button"
            color="secondary"
            outline
            onClick={dismissModal}
          >
            <FormattedMessage id="Cancel" />
          </Button>
          <Button type="submit" outline color="primary" disabled={isSubmitting}>
            {isSubmitting ? (
              <>
                <FormattedMessage id="Wait" />
              </>
            ) : (
              <>
                <FormattedMessage id="Import" />
              </>
            )}
          </Button>
        </ModalFooter>
      </Form>
    </div>
  );
};

const toFormData = (file) => {
  if (!file) return null;

  var myData = new FormData();
  myData.append("excelFile", file);
  return myData;
};

const FormikForm = withFormik({
  mapPropsToValues: (props) => ({
    studentClassId: props.preSelectedClassId || -1,
    file: props.file,
  }),

  validationSchema: Yup.object().shape({
    studentClassId: Yup.number().min(
      1,
      <FormattedMessage id="Views.Teacher.CreateStudentForm.Error.SelectClass" />
    ),
  }),

  handleSubmit(values, { props, resetForm, setErrors, setSubmitting }) {
    if (!values.file) {
      setErrors({
        file: (
          <FormattedMessage id="Views.Teacher.ImportStudentsForm.Error.SelectFile" />
        ),
      });
      setSubmitting(false);
      return;
    }

    axios
      .post(
        "/Student/AddToClassByFile?ClassId=" + values.studentClassId,
        toFormData(values.file),
        { headers: { "Content-Type": "multipart/form-data;" } }
      )
      .then((response) => {
        toast.success(
          <FormattedMessage id="Tostify.Message.ImportedStudents" />,
          TOAST_CONFIG
        );
        props.updateStudents();
        props.dismissModal();
      })
      .catch((err) => {
        setErrors({
          file: err.response
            ? err.response.data.split("\n").map(function (item, key) {
                return (
                  <span key={key}>
                    {item}
                    <br />
                  </span>
                );
              })
            : null,
        });
        setSubmitting(false);
      });
  },
})(ImportForm);

export default FormikForm;
